module.exports = __webpack_public_path__ + "static/media/flight_land-24px.a5b581a8.svg";